import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';
import moment from 'moment';

interface uploadFileProps extends CacheProps {
  file: any
  type: string
}

const uploadFileApi = ({ file, type, ...rest }: uploadFileProps) => {
  const formData = new FormData();
  formData.append('file', file);

  return fetchApi({
    method: 'POST',
    uploadFile: true,
    URL: {
      pathname: routes['api.consults.upload-file'],
      query: {
        type: type,
        day: moment().format('DD'),
        month: moment().format('MM'),
        year: moment().format('YYYY'),
        sectionType: 'consults',
        sectionTypeDate: 'consult_dialogue',
        time: moment().unix().toString(),
      },
    },
    payload: formData,
    withToken: true,
    ...rest,
  });
};

export default uploadFileApi;
